import { createReducer, on } from '@ngrx/store';
import * as LoadingActions from './actions';

export interface LoadingState {
  [key: string]: boolean;
}

export const initialState: LoadingState = {};

export const loadingReducer = createReducer(
  initialState,
  on(LoadingActions.setLoading, (state, { key, loading }) => ({
    ...state,
    [key]: loading
  })),
  on(LoadingActions.clearAllLoading, () => initialState)
);
